{
	"quantitySelector": {
		"qtySlider": "{{qty}} шт.",
		"pcs": "шт.",
		"maxQty": "Значение превышает количество, доступное в вашем портфеле"
	}
}
